import React from 'react'
import PropTypes from 'prop-types'
import { Footer } from './Footer.styled'
import FooterText from './FooterText'
import Headings from '../Headings'
import PairNavButton from '../PairNavButton'

const PageFooter = ({
  title,
  contents,
  leftButton,
  leftButtonFunc,
  leftButtonLabel,
  isLeftButtonDisabled,
  navModalBtnFocused,
  rightButton,
  rightButtonFunc,
  rightButtonLabel,
  isRightButtonDisabled,
  haveShadow,
}) => {
  return (
    <Footer haveShadow={title || haveShadow}>
      {title && <Headings level="h2" text={title}></Headings>}

      {contents &&
        contents.map((content, index) => (
          <FooterText content={content} key={index} />
        ))}

      {leftButton && (
        <PairNavButton
          leftButton={leftButton}
          leftButtonFunc={leftButtonFunc}
          leftButtonLabel={leftButtonLabel}
          isLeftButtonDisabled={isLeftButtonDisabled}
          isLeftBtnFocused={navModalBtnFocused}
          rightButton={rightButton}
          rightButtonFunc={rightButtonFunc}
          rightButtonLabel={rightButtonLabel}
          isRightButtonDisabled={isRightButtonDisabled}
        />
      )}
    </Footer>
  )
}
PageFooter.propTypes = {
  title: PropTypes.string,
  contents: PropTypes.array,
  leftButton: PropTypes.string,
  leftButtonFuc: PropTypes.func,
  isLeftButtonDisabled: PropTypes.bool,
  rightButton: PropTypes.string,
  rightButtonFuc: PropTypes.func,
  isRightButtonDisabled: PropTypes.bool,
}
export default PageFooter
